import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { OptionProps } from 'react-select';

type OptionLayoutOption = {
  label: string;
  value?: string;
  icon?: IconProp;
};

type OptionLayoutIconProps = OptionProps<OptionLayoutOption, false>;

const OptionLayoutIcon = (props: OptionLayoutIconProps) => {
  const { innerProps, innerRef } = props;
  return (
    <>
      <style>{`
          .customized-searchbox-option:hover{
            background-color:var(--falcon-gray-link-hover-300) !important;
          }
          .customized-searchbox-option{
            background-color:var(--falcon-tertiary-bg) !important;
          }
    
          `}</style>
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          backgroundColor: props.isSelected
            ? 'var(--falcon-gray-link-hover-100)'
            : 'var(--falcon-dropdown-bg-global)'
        }}
        className="p-2 cursor-pointer border border-1  customized-searchbox-option"
      >
        <div className="fs--1 text-900 d-flex align-items-center gap-2">
          {props.data?.icon && (
            <FontAwesomeIcon
              icon={props.data.icon}
              title={
                typeof props.data.icon === 'string'
                  ? props.data.icon
                  : undefined
              }
            />
          )}
          {props.data.label}{' '}
        </div>
      </div>
    </>
  );
};

export default OptionLayoutIcon;
